import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import {
  Radio,
  RadioGroup,
} from '~/client/src/shared/components/shadcn-ui/radio-group'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import PermitApprovalStore from '../PermitApproval.store'

interface IProps {
  store: PermitApprovalStore
}

// A sign-off on a one-sign-off-per-rule step counts toward one rule. When the user is in
// several of the rules still waiting, they pick which one this sign-off is for.
const BicRuleChoiceDialog: React.FC<IProps> = ({ store }) => {
  const { ruleChoices, chooseRule, cancelRuleChoice } = store
  const [ruleId, setRuleId] = React.useState<string>(null)

  React.useEffect(() => {
    setRuleId(ruleChoices?.[0]?.ruleId ?? null)
  }, [ruleChoices])

  return (
    <ConfirmDialog
      isOpen={!!ruleChoices}
      title={Localization.translator.completeForWhichRule}
      onCancelClicked={cancelRuleChoice}
      onDoneClicked={() => chooseRule(ruleId)}
      cancelTitle={Localization.translator.goBack}
      doneTitle={Localization.translator.continue}
      doneDisabled={!ruleId}
    >
      <div className="tw:flex tw:flex-col tw:gap-3">
        <span className="tw:text-app-body tw:text-muted-foreground">
          {Localization.translator.countsTowardOneRule}
        </span>
        <RadioGroup
          value={ruleId}
          onValueChange={value => setRuleId(value as string)}
        >
          {ruleChoices?.map(rule => (
            <label
              key={rule.ruleId}
              className="tw:flex tw:cursor-pointer tw:items-center tw:gap-2"
            >
              <Radio value={rule.ruleId} />
              <span className="tw:text-app-body tw:text-foreground">
                {rule.name}
              </span>
            </label>
          ))}
        </RadioGroup>
      </div>
    </ConfirmDialog>
  )
}

export default observer(BicRuleChoiceDialog)
